import { useState, useEffect } from 'react';
import { RefreshCw, Rocket } from 'lucide-react';

export default function UpdateNotification() {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    const handler = () => setShowUpdate(true);
    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  if (!showUpdate) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-[9999] flex items-center gap-4 px-5 py-4 rounded-xl bg-[#1A2332] text-white shadow-2xl max-w-[400px] animate-in slide-in-from-bottom-4 duration-300"
      data-testid="update-notification"
    >
      <div className="w-10 h-10 rounded-lg bg-[var(--lumyn-content)]/20 flex items-center justify-center shrink-0">
        <Rocket className="w-5 h-5 text-[var(--lumyn-content)]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm">Update available</p>
        <p className="text-xs text-white/60">A new version of Lumyn is ready</p>
      </div>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 rounded-lg bg-[var(--lumyn-content)] text-white text-sm font-semibold hover:bg-[var(--lumyn-content)]/90 transition-colors flex items-center gap-1.5 shrink-0"
        data-testid="refresh-btn"
      >
        <RefreshCw className="w-3.5 h-3.5" /> Refresh
      </button>
    </div>
  );
}
